import React from 'react';
import { COMPONENTS } from '~/utils/components';
import { renderComponent } from '~/utils/helpers';

interface MapProps {
  items: string;
  itemKeyWord?: string;
  component: any;
  data: any;
  images: any;
}

export const Map: React.FC<MapProps> = ({
  items,
  component,
  data = {},
  images = {},
  itemKeyWord = 'item',
}) => {
  const parsedItems = JSON.parse(items);

  if (!Array.isArray(parsedItems)) return null;

  const mappedItems = parsedItems.map((item, index) => ({
    ...component,
    props: {
      ...component.props,
      [itemKeyWord]: item,
      [`${itemKeyWord}Index`]: index,
    },
  }));

  return renderComponent({
    componentData: mappedItems,
    components: COMPONENTS,
    data,
    allProps: {},
    images,
  });
};
